import { walkLayout } from '@tencent/ui-core/lib/utils';
import { isEqual } from 'lodash';
import useBaseDepLoader from '@composables/useDepLoader';
const AI_BLOCK_COMPONENT = 'public-w-ai-html';
const DEFAULT_PAGELET_ID = 'default';
const PageType = {
    lowcode: 'lowcode',
    ai: 'ai',
    code: 'code',
};
const getPageType = (pageConfig) => {
    if (Array.isArray(pageConfig)) {
        return PageType.lowcode;
    }
    if (pageConfig.fsStore) {
        return PageType.ai;
    }
    return PageType.code;
};
const handleLowCodePageConfig = (pageConfig, isSaveStage = false) => {
    const defaultPageConfig = pageConfig.find((pagelet) => pagelet.id === DEFAULT_PAGELET_ID);
    // 如果是非保存阶段调用这个函数 - 比如加载页面信息的时候
    // 直接返回defaultPage的dependencies就好
    if (!isSaveStage) {
        return new Set(defaultPageConfig.dependencies);
    }
    const dependencies = new Set();
    pageConfig.forEach((pagelet) => {
        walkLayout(pagelet.layout, (step) => {
            if (!(step.layout.type === AI_BLOCK_COMPONENT)) {
                return;
            }
            if (step.layout.props?.dependencies) {
                step.layout.props?.dependencies.split(',').forEach((dep) => {
                    dependencies.add(dep);
                });
            }
        });
        return dependencies;
    });
    // 更新default页面里的dependencies字段
    const items = Array.from(dependencies);
    // Note: 这里不判断 Equal 会引起内嵌页面片使用当前页面片的选择器重刷！！！
    if (!isEqual(items, defaultPageConfig.dependencies)) {
        defaultPageConfig.dependencies = items;
    }
    return dependencies;
};
export const getDependencyFromPageConfig = (pageConfig, isSaveStage = true) => {
    const pageType = getPageType(pageConfig);
    switch (pageType) {
        case PageType.lowcode:
            return handleLowCodePageConfig(pageConfig, isSaveStage);
        case PageType.ai:
        case PageType.code:
        default:
            return null;
    }
};
const useDepLoader = () => {
    const { loadDependencies: loadDependenciesBase, updateDependency: updateDependencyBase, } = useBaseDepLoader();
    const loadDependencies = (bus) => {
        const { pageConfig } = bus.baseData;
        const dependencies = getDependencyFromPageConfig(pageConfig, false);
        if (!dependencies) {
            return;
        }
        return loadDependenciesBase(dependencies);
    };
    const updateDependency = async (_editor, bus) => {
        const { baseData } = bus;
        const { pageConfig } = baseData;
        const dependencies = getDependencyFromPageConfig(pageConfig);
        if (!dependencies) {
            return;
        }
        return updateDependencyBase(dependencies, baseData.pageId);
    };
    return {
        loadDependencies,
        updateDependency,
    };
};
export default useDepLoader;
